import React from 'react';
import {
  getClassificationColor,
  getClassificationSolidColor,
  getClassificationLabel,
} from '../../utils/classificationConfig';

/**
 * Employee Classification Badge.
 *
 * Renders a pill badge colored by employment classification.
 * Uses the canonical color mapping from classificationConfig.js.
 *
 * @param {string}  classification - Key: 'worker', 'staff', 'executive_director', etc.
 * @param {string}  [label]        - Override display text
 * @param {'md'}    [size]         - Optional 'md' for hero/prominent contexts
 * @param {'solid'} [variant]      - Optional 'solid' for staff ID chips (white text on colored bg)
 */
export const ClassificationBadge = ({ classification, label, size, variant }) => {
  const displayLabel = label || getClassificationLabel(classification);
  const colorClasses = variant === 'solid'
    ? getClassificationSolidColor(classification)
    : getClassificationColor(classification);
  const sizeClasses = size === 'md' ? 'px-3 py-1' : 'px-2.5 py-0.5';
  const ringClass = variant === 'solid' ? '' : 'ring-1 ring-inset';

  return (
    <span
      className={`inline-flex items-center rounded-full text-xs font-medium ${ringClass} ${colorClasses} ${sizeClasses}`}
    >
      {displayLabel}
    </span>
  );
};

export default ClassificationBadge;
